module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showQuitModal),
      expression: "showQuitModal"
    }],
    staticClass: "pop-quit",
    on: {
      "click": _vm.closeQuitModal
    }
  }, [_c('div', {
    staticClass: "pop-body",
    on: {
      "click": _vm.preventDefault
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.imgUrl
    },
    on: {
      "click": _vm.toFreeGet
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c72a440!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TuiaQuitBox.vue
// module id = 20
// module chunks = 2 3 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 60 61 62 65 66 83 84 85 86 87 88 89 125